module.exports = __webpack_public_path__ + "static/coursera-ui.47ec7c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/coursera-ui.png
// module id = 844
// module chunks = 73261030922168